import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { useFavorites } from "~/hooks/use-favorites.hook";
import { captureEvent } from "~/tooling/telemetry/capture-event";
import { navigationClickedEvent } from "~/tooling/telemetry/events";
import { HeaderFavoritesButtonIcon } from "./auth.header-favorites-button-icon.component";

export function HeaderFavoritesButton() {
	const navigate = useNavigate();
	const { t } = useTranslation("common");
	const { favoriteIds } = useFavorites();
	const hasFavorites = favoriteIds.length > 0;

	const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
		const label = t("header.favorites.label");
		captureEvent(navigationClickedEvent(e.currentTarget.id, label, "main"));
		navigate("/favorites");
	};

	return (
		<HeaderFavoritesButtonIcon
			id="header-favorites-button"
			data-testid="header-favorites-button"
			aria-label={t("header.favorites.label")}
			showStatusBadge={hasFavorites}
			onClick={handleClick}
		/>
	);
}
